export class UserVendor {
  constructor(
    public vendorName: string,
    public userId?: number,
    public isDefault?: boolean,
    public vendorDescription?: string,
    public isMontovaCompatible?: boolean,
  ) {}
}
